import { render, staticRenderFns } from "./PageAlarmsTabPositiveAndNegative.vue?vue&type=template&id=52f53847&"
import script from "./PageAlarmsTabPositiveAndNegative.vue?vue&type=script&lang=ts&"
export * from "./PageAlarmsTabPositiveAndNegative.vue?vue&type=script&lang=ts&"
import style0 from "./PageAlarmsTabPositiveAndNegative.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDataTable,VDialog})
